import ClearingAPI from '@shared/api';

export const {
    dailySettlements: { getCurrent: getDailySettlement },
} = ClearingAPI.settings;
